import { TrackActionRequest } from '@1po/1po-bff-fe-spec/generated/analytics/request/TrackActionRequest';
import { TRACK_ACTION } from '@1po/1po-bff-fe-spec/src/analytics/AnalyticsURLs';
import { RootState } from 'app/AppStore';
import { getData } from 'utils';
import { WebSocketAction } from 'utils/domainStore/domain.types';
import { WS_ACTION_TRACK } from '../WebSocket.types';

export function createUserMonitoringAction(action: WebSocketAction, getState: () => RootState): WebSocketAction {
  const userData = getData(getState().user.tokenUser.user);
  const commercialLink = getState().user.commercialLink;
  const request: TrackActionRequest = {
    action: action.type,
    payload: action.payload,
    metadata: {
      userId: userData?.id ?? '',
      userName: [userData?.firstName ?? '', userData?.lastName ?? ''].join(' ').trim(),
      entityId: commercialLink?.buyerId ?? '',
      entityName: commercialLink?.name ?? '',
      navigator: {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    },
  };
  return {
    ...action,
    type: WS_ACTION_TRACK,
    url: TRACK_ACTION,
    payload: request,
  };
}
